export const formatErrorsToArray = (errors: unknown) => {
  if (!errors) return [];

  if (
    Array.isArray(errors) &&
    errors.every(
      (error) =>
        error &&
        typeof error === 'object' &&
        'field' in error &&
        'message' in error
    )
  ) {
    return errors;
  }

  if (typeof errors === 'object' && !Array.isArray(errors)) {
    return Object.entries(errors as Record<string, unknown>).map(
      ([field, error]) => ({
        field,
        message: (error as { message?: string })?.message || String(error),
        type: (error as { type?: string })?.type,
      })
    );
  }

  if (Array.isArray(errors)) {
    return errors.map((error, index) => ({
      field:
        (error as { property?: string; field?: string })?.property ||
        (error as { property?: string; field?: string })?.field ||
        `error_${index}`,
      message: (error as { message?: string })?.message || String(error),
    }));
  }

  return [];
};
